import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import Grid from '@mui/material/Unstable_Grid2';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import useMediaQuery from '@mui/material/useMediaQuery';

import FilterCondition from './FilterCondition';

import { handleApiRequest } from '../../api';
import useApiError from '../../hook/useApiError';
import useGlobalStatus from '../../hook/useGlobalStatus';

import Loading from '../../components/loading/Loading';
import AlertMsg from '../../components/alert/AlertMsg';
import TabIndex from '../../components/tab/TabIndex';

import { ALERT_TYPE, ERROR_DOWNLOAD_EXCEL } from '../../constants/alertMsg';

import { yesterday, last7day, formatDate2, formatDate3 } from '../../utils/date';

import theme from '../../theme';

import { TEST_USER } from './constants';


const WishItem = (props) => {
  const { handleAlertMsgSettings } = useGlobalStatus();
  const { handleApiErrorStatus } = useApiError();
  const [isLoading, setIsLoading] = useState(true);
  const [dateRange, setDateRange] = useState({ startDate: last7day, endDate: yesterday });
  const [searchKeyword, setSearchKeyword] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [userList, setUserList] = useState([]);
  const [sortUserList, setSortUserList] = useState([]);
  const isMoblie = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    getUserList();
  }, [dateRange])

  useEffect(() => {
    if (!searchKeyword) {
      getUserList();
    }
  }, [searchKeyword])

  const getUserList = () => {
    setIsLoading(true);

    const filterCondition = new URLSearchParams({
      start_date: dateRange.startDate ? formatDate2(dateRange.startDate) : '',
      end_date: dateRange.endDate ? formatDate2(dateRange.endDate) : '',
      search_phrase: searchKeyword.trim()
    })

    handleApiRequest('getUserList', filterCondition)
      .then(res => {
        if (res.status === 200) {
          const resultData = res.data.result;
          // const sliceData = resultData.slice(0, rowsPerPage);
          setUserList(resultData);
          setSortUserList(resultData);

          setIsLoading(false);
        } else {
          handleApiErrorStatus(res);
        }
      })
  }

  const fetchDownloadUser = () => {
    if (!userList.length) {
      handleAlertMsgSettings(true, { type: ALERT_TYPE.ERROR, msg: ERROR_DOWNLOAD_EXCEL });
      return;
    }

    setIsLoading(true);
    const filterCondition = new URLSearchParams({
      search_phrase: searchKeyword,
      start_date: dateRange.startDate ? formatDate2(dateRange.startDate) : '',
      end_date: dateRange.endDate ? formatDate2(dateRange.endDate) : '',
    })

    handleApiRequest('getDownloadCsv', filterCondition)
      .then(res => {
        if (res.status === 200) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = formatDate3(dateRange.startDate) + '-' + formatDate3(dateRange.endDate) + '_使用者清單' + '.csv';
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          handleApiErrorStatus(res);
        }
        setIsLoading(false);
      })
  }

  return (
    <>
      <Box mt={2} sx={{ position: 'relative' }}>
        {
          isMoblie &&
          <Box>
            <FilterCondition
              searchKeyword={searchKeyword}
              dateRange={dateRange}
              setDateRange={setDateRange}
              isLoading={isLoading}
              fetchDownloadUser={fetchDownloadUser}
              getUserList={getUserList}
            />
          </Box>
        }
        <Box>
          <TabIndex
            dateRange={dateRange}
            searchKeyword={searchKeyword}
            userList={userList}
            setUserList={setUserList}
            sortUserList={sortUserList}
            setSortUserList={setSortUserList}
            getUserList={getUserList}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </Box>
        {
          !isMoblie &&
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              top: { xs: 60, md: 0 },
              width: { xs: '100%', md: '80%' }
            }}
          >
            <Stack variant='end-center'>
              <FilterCondition
                searchKeyword={searchKeyword}
                setSearchKeyword={setSearchKeyword}
                dateRange={dateRange}
                setDateRange={setDateRange}
                isLoading={isLoading}
                fetchDownloadUser={fetchDownloadUser}
                getUserList={getUserList}
              />
            </Stack>
          </Box>
        }
      </Box>

      <AlertMsg />

      <Loading
        isLoading={isLoading}
        content='資料讀取中，請稍後...'
      // variant="inside"
      // invisibleBg={true}
      />
    </>
  )
}

export default WishItem;